import { useNavigate } from "react-router-dom"

import {
  MetricHeaderMid,
  MetricHeaderLeft,
  MetricHeaderRight,
  MetricHeaderWrapper,
} from "../Atom"
import { HeaderInfoNav } from "../Reusable"
import AddNewUserButton from "../../Button/AddNewUserButton"
import PermsWrapper from "../../Auth/PermsWrapper"
import { permissions } from "../../../../config/constants"

export default function UserManagementHeader({ name, setOpen }: any) {
  const navigate = useNavigate()

  const handleClickBack = (e: any) => {
    navigate(-1)
  }

  return (
    <>
      <MetricHeaderWrapper>
        <MetricHeaderLeft>
          <HeaderInfoNav name={name} handleClickBack={handleClickBack} />
        </MetricHeaderLeft>

        <MetricHeaderMid></MetricHeaderMid>

        <MetricHeaderRight>
          <PermsWrapper perm={permissions?.INVITE_USER}>
            <AddNewUserButton setOpen={setOpen} />
          </PermsWrapper>
        </MetricHeaderRight>
      </MetricHeaderWrapper>
    </>
  )
}
